import { render } from "./coOccurrence.vue?vue&type=template&id=63e3f976&ts=true"
import script from "./coOccurrence.vue?vue&type=script&lang=ts&config=true"
export * from "./coOccurrence.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__